import {
  CheckCircle2, ChevronRight, Clock3, Gauge, LogOut, Menu,
  Landmark, PanelLeftClose, RotateCcw, ShoppingBag, Truck, X, type LucideIcon,
} from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import clsx from "clsx";
import type { SessionUser } from "../lib/api";

const navigation: Array<[string, string, LucideIcon]> = [
  ["Dashboard", "/", Gauge],
  ["Orders", "/orders", ShoppingBag],
  ["Pending orders", "/pending", Clock3],
  ["Dispatched", "/dispatched", Truck],
  ["Delivered", "/delivered", CheckCircle2],
  ["Returns", "/returns", RotateCcw],
];

export function Layout({ user, onLogout }: { user: SessionUser; onLogout: () => void }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const pendingOnly = user.permissions.includes("view_pending_orders") && !user.permissions.includes("view_orders");
  const visibleNavigation = pendingOnly ? navigation.filter((item) => item[1] === "/pending") : navigation;
  const title = location.pathname.startsWith("/orders/")
    ? "Order details"
    : visibleNavigation.find((item) => item[1] === location.pathname)?.[0] || "Order Desk";
  return <div className={clsx("app-shell", collapsed && "nav-collapsed")}>
    <aside className={clsx("sidebar", mobileOpen && "mobile-open")}>
      <div className="brand-lockup"><div className="brand-mark"><Landmark size={23} strokeWidth={1.7} /></div><div><strong>Razzi Designs</strong><span>Order Desk</span></div><button className="icon-button mobile-only" onClick={() => setMobileOpen(false)} aria-label="Close navigation"><X size={19} /></button></div>
      <nav aria-label="Main navigation">
        {visibleNavigation.map(([label, path, Icon]) => <NavLink key={path} to={path} end={path === "/"} onClick={() => setMobileOpen(false)} className={({ isActive }) => clsx("nav-item", isActive && "active")} title={collapsed ? label : undefined}>
          <Icon size={18} /><span>{label}</span>
        </NavLink>)}
      </nav>
      <button className="collapse-button" onClick={() => setCollapsed((value) => !value)}>{collapsed ? <ChevronRight size={17} /> : <><PanelLeftClose size={17} /><span>Collapse</span></>}</button>
    </aside>
    <div className="main-column">
      <div className="topbar">
        <button className="icon-button mobile-only" onClick={() => setMobileOpen(true)} aria-label="Open navigation"><Menu size={20} /></button>
        <div className="topbar-title"><span>Razzi Designs</span><strong>{title}</strong></div>
        <div className="topbar-tools"><div className="user-chip"><span>{user.name.slice(0, 1).toUpperCase()}</span><div><strong>{user.name}</strong><small>{user.roles[0] || "Staff"}</small></div></div><button className="icon-button" onClick={onLogout} title="Sign out" aria-label="Sign out"><LogOut size={18} /></button></div>
      </div>
      <main><Outlet /></main>
    </div>
  </div>;
}
